import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "./api";
import type { ProfileDraft } from "./ProfileForm";

const key = ["portal", "security", "profiles"] as const;

export const useProfiles = () =>
  useQuery({ queryKey: key, queryFn: api.listProfiles });

export function useProfileMutations() {
  const client = useQueryClient();
  const invalidate = () => client.invalidateQueries({ queryKey: key });
  return {
    create: useMutation({
      mutationFn: (input: ProfileDraft) => api.createProfile(input),
      onSuccess: invalidate,
    }),
    edit: useMutation({
      mutationFn: ({ id, input }: { id: string; input: ProfileDraft }) =>
        api.editProfile(id, input),
      onSuccess: invalidate,
    }),
    inactivate: useMutation({
      mutationFn: ({ id, confirmed }: { id: string; confirmed: boolean }) =>
        api.inactivateProfile(id, confirmed),
      onSuccess: invalidate,
    }),
  };
}
